module.exports = __webpack_public_path__ + "static/img/278_TO8_2416_og.2ce0b15.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/278_TO8_2416_og.jpg
// module id = 80mQ
// module chunks = 0